import { render } from "./TheModalDelete.vue?vue&type=template&id=75d58d4c"
import script from "./TheModalDelete.vue?vue&type=script&lang=js"
export * from "./TheModalDelete.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos Node\\LWP\\Nil Key\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__